import { attachWsListeners } from '~/providers/SocketContext/create-socket/attach-ws-listeners';
import { sharedWebSocket } from '~/providers/SocketContext/create-socket/shared/constants';
import { type CreateOrJoinArgs } from '~/providers/SocketContext/create-socket/shared/typings';
import { ReadyState } from '~/types/sockets';

export const createSocket = async ({ webSocketRef, url, setReadyState, reconnect, messageQueue }: CreateOrJoinArgs) => {
  if (sharedWebSocket.ws === null) {
    sharedWebSocket.ws = new WebSocket(url);
    webSocketRef.current = sharedWebSocket.ws;
    setReadyState(ReadyState.CONNECTING);

    attachWsListeners({
      webSocketInstance: sharedWebSocket.ws,
      setReadyState,
      reconnect,
      messageQueue,
    });
  } else {
    webSocketRef.current = sharedWebSocket.ws;
    setReadyState(sharedWebSocket.ws.readyState);
  }
};
